import React, { Component } from 'react'
import { reaction } from 'mobx'
import { observer, inject } from 'mobx-react'

import RankItem from './RankItem'

import config from '../config'
import api from '../services'
const { pvIds } = config

@inject('cityInfo')
@observer
export default class RankFloor extends Component {
  constructor(props){
    super(props)
    this.state = {
      cpsCitys: [],
      tabIndex: 0,
      tabData: ['本周销量榜','高性价比榜','热门人气榜','精选豪车榜'],
      totalData: [],
      list: [],
      minPriceList: []
    }

    this.loadData = this.loadData.bind(this)
    this.getPrice = this.getPrice.bind(this)
    this.getMinPrice = this.getMinPrice.bind(this)
    this.tab = this.tab.bind(this)

    reaction(
      () => this.props.cityInfo.info.cityId,
      cityId => this.loadData()
    )
  }

  async loadData(){
    let { cityInfo } = this.props,cityId = cityInfo.info.cityId,cpsCitys = [],_this = this

    await new Promise((resolve,reject) => {
      api.getCities()
      .then(data => {
        if(data.returncode === 0){
          data.result.map(ele => cpsCitys.push(ele.cityId))
          if(cpsCitys.indexOf(cityId) === -1){
            _this.setState({tabData: ['本周销量榜','高性价比榜','热门人气榜']},resolve)
          }else {
            _this.setState({tabData: ['本周销量榜','高性价比榜','热门人气榜','精选豪车榜']},resolve)
          }
        }
      })
      .catch(() => {
        _this.setState({tabData: ['本周销量榜','高性价比榜','热门人气榜']},reject)
      })
    })
    
    let getDataPromiseArr = this.state.tabData.map((ele,index) => api.getRankingList({
      rankType: ++index,
      cityId
    }))

    Promise.all([...getDataPromiseArr])
      .then(data => {
        let list = [],totalData = [],
        tabData = this.state.tabData
        totalData = data.filter((ele,index) => {
          if(ele.returncode === 0 && ele.result.length === 5){
            list = list.concat(ele.result)
          }else {
            tabData[index] = false
          }
          return ele.returncode === 0 && ele.result.length === 5
        })
        this.setState({
          list,
          tabData:tabData.filter(ele => !!ele),
          totalData
        },this.getPrice)
      })
      .catch(()=>{})
  }

  tab(index){
    let ctype = '本周销量榜'
    switch(index){
      case 0:
        ctype = '本周销量榜'
        break;
      case 1:
        ctype = '高性价比榜'
        break;
      case 2:
        ctype = '热门人气榜'
        break;
      case 3:
        ctype = '精选豪车榜'
        break;
    }

    // 统计
    window.trackCustomEvent('auto_common_event',{
      'biz':'ec',
      'scene':0,
      'type':'click',
      'action':'mall_m_redpacket_sale_list_click',
      'ctime':new Date().getTime(),
      'area':0,
      'element':0,
      'pmark':0,
      'target':0,
      'ctype':ctype,
      'cid':0
    },{
      'ek1':0,
      'ek2':0
    })
    this.setState({tabIndex:index})
  }
  
  getPrice(){
    let { cityInfo } = this.props

    api.getPriceForList({
      city: cityInfo.info.cityId,
      itemIds: this.state.list.map(item => item.itemId).join(',')
    }).then(data => {
      if(data.returncode === 0){
        this.setState({
          minPriceList: data.result
        })
      }
    }).catch(()=>{})
  }

  getMinPrice(itemId) {
    let list = this.state.minPriceList
    return list.length ?
              list.filter(item => item.item.itemId === itemId)[0] ?
                list.filter(item => item.item.itemId === itemId)[0].minPrice
                  :
                  0
              :
              0
  }

  componentDidMount(){
    this.loadData()
  }
  
  render(){
    let { tabData, tabIndex, totalData } = this.state,showList

    if(totalData.length === 0) return null

    showList = totalData[tabIndex].result

    return(
      <div className={this.state.list.length?'':'fn-hide'}>
        <div className='title'>
          <span>霸榜好车</span>
          <span className='title--exp'>榜单基于汽车之家大数据 每天1:00更新</span>
        </div>
        <div className='tabBar'>
          {
            tabData.map(
              (tab,index) => <span key={index} className={tabIndex === index?'tabBar__item cur':'tabBar__item'}
                                    onClick={() => this.tab(index)}>{tab}</span>
            )
          }
        </div>
        {
          showList.map(
            (item,index) => <RankItem key={Math.random()}
                              index={index}
                              goods={item}
                              pvId={pvIds.rank}
                              minPrice={this.getMinPrice(item.itemId)} />
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/RankFloor.js